// // jQuery(document).ready(function($){

// //   // ============================================================
// //   // DS: AUTO-REPLACE LOGIC (Clean Cooking Set)
// //   // ============================================================
// //   // var inPro  = [8877080772867, 8876670091523];
// //   // var addPro = [46384684138755, 46384684171523];

// //   function checkSet(){
// //     var proList     = [];
// //     var variantList = [];
// //     var checkVariant = '';

// //     $.ajax({
// //       type: 'GET',
// //       url: '/cart.js',
// //       dataType: 'json',
// //       success: function(res) {
// //         if(res.items.length > 0){
// //           res.items.forEach(function(item){
// //             if(item.variant_title != null) checkVariant += item.variant_title + ' ';
// //             proList.push(item.product_id);
// //             variantList.push(item.variant_id);
// //           });
// //         }

// //         var allExist = inPro.every(function(v){ return proList.includes(v); });
// //         if(allExist){
// //           var addVariantId;
// //           if(checkVariant.indexOf('Midnight Black') > -1){
// //             addVariantId = addPro[1];
// //           } else if(checkVariant.indexOf('Cadmium Orange') > -1){
// //             addVariantId = addPro[0];
// //           }
// //           removeAddPro(variantList, addVariantId);
// //         }
// //       }
// //     });
// //   }

// //   function removeAddPro(variantList, addVariantId){
// //     if(variantList.length === 0){ console.error('variantList is empty'); return; }

// //     var updates = {};
// //     variantList.forEach(function(id){ updates[id] = 0; });

// //     $.ajax({
// //       type: 'POST',
// //       url: '/cart/update.js',
// //       data: { updates: updates },
// //       dataType: 'json',
// //       success: function(){
// //         $.ajax({
// //           type: 'POST',
// //           url: '/cart/add.js',
// //           data: { id: addVariantId, quantity: 1 },
// //           dataType: 'json',
// //           success: function(){ SLIDECART_UPDATE(); }
// //         });
// //       },
// //       error: function(xhr, status, error){ console.error('Error removing products:', error); }
// //     });
// //   }

// //   setTimeout(function(){ checkSet(); }, 2000);


// //   // ============================================================
// //   // PRICE CALCULATOR
// //   // FIX: Unified price update for solo / bundle / premium tabs.
// //   //      All Liquid prices are CENTS (integers).
// //   //      bundleSaveMine[price]   = sum of bundle line items (cents)
// //   //      totalproresult[totalprice] = main product price (cents)
// //   //      totalPriceMine[totalprice] = main + bundle total (cents) [preferred]
// //   //      We NEVER double-add the main product price.
// //   // ============================================================
// //   function updateTotalPrice(){
// //     // Addon/warranty checkbox totals (cents)
// //     var addonTotal   = 0;
// //     var addonCompare = 0;
// //     $('input[type="checkbox"]:checked').each(function(){
// //       addonTotal   += parseFloat($(this).data('price'))        || 0;
// //       addonCompare += parseFloat($(this).data('regularprice')) || 0;
// //     });

// //     // Main product base prices (cents) from totalproresult div
// //     var mainPrice   = parseFloat($('.totalproresult').attr('totalprice'))   || 0;
// //     var mainCompare = parseFloat($('.totalproresult').attr('compareprice')) || 0;

// //     if($('#bundle_save').hasClass('active')){
// //       // FIX: Prefer totalPriceMine which Liquid already computed correctly
// //       var $totalMine = $('#bundle .totalPriceMine');
// //       if($totalMine.length){
// //         var finalPrice   = (parseInt($totalMine.attr('totalprice'))   || 0) + addonTotal;
// //         var finalCompare = (parseInt($totalMine.attr('compareprice')) || 0) + addonCompare;
// //         _displayBundlePrice(finalPrice, finalCompare);
// //       } else {
// //         // Fallback: add main + bundle items + addons
// //         var bundleItemsPrice   = parseInt($('#bundle .bundleSaveMine').attr('price'))   || 0;
// //         var bundleItemsCompare = parseInt($('#bundle .bundleSaveMine').attr('compare')) || 0;
// //         var finalPrice   = mainPrice   + bundleItemsPrice   + addonTotal;
// //         var finalCompare = mainCompare + bundleItemsCompare + addonCompare;
// //         _displayBundlePrice(finalPrice, finalCompare);
// //       }

// //     } else if($('#premium_set').hasClass('active')){
// //       var $totalMine = $('#premium .totalPriceMine');
// //       if($totalMine.length){
// //         var finalPrice   = (parseInt($totalMine.attr('totalprice'))   || 0) + addonTotal;
// //         var finalCompare = (parseInt($totalMine.attr('compareprice')) || 0) + addonCompare;
// //         _displayBundlePrice(finalPrice, finalCompare);
// //       } else {
// //         var bundleItemsPrice   = parseInt($('#premium .bundleSaveMine').attr('price'))   || 0;
// //         var bundleItemsCompare = parseInt($('#premium .bundleSaveMine').attr('compare')) || 0;
// //         var finalPrice   = mainPrice   + bundleItemsPrice   + addonTotal;
// //         var finalCompare = mainCompare + bundleItemsCompare + addonCompare;
// //         _displayBundlePrice(finalPrice, finalCompare);
// //       }

// //     } else {
// //       // Solo tab
// //       var soloPrice   = parseFloat($('.soloTotalPrice').attr('totalprice'))   || mainPrice;
// //       var soloCompare = parseFloat($('.soloTotalPrice').attr('compareprice')) || mainCompare;
// //       var finalPrice   = soloPrice   + addonTotal;
// //       var finalCompare = soloCompare + addonCompare;

// //       if($('.price--on-sale').length <= 0){
// //         if(finalPrice < finalCompare){
// //           $(".discounted_pricing").text("$" + (finalCompare / 100).toFixed(2));
// //         }
// //         $(".price-item.price-item--regular").text("$" + (finalPrice / 100).toFixed(2));
// //       } else {
// //         $(".price-item.price-item--sale.price-item--last").text("$" + (finalPrice / 100).toFixed(2));
// //         $(".price__sale .price-item.price-item--regular").text("$" + (finalCompare / 100).toFixed(2));
// //       }
// //     }
// //   }

// //   // Helper: write bundle/premium price to all relevant DOM elements
// //   function _displayBundlePrice(saleCents, compareCents){
// //     var saleStr    = "$" + (saleCents    / 100).toFixed(2);
// //     var compareStr = "$" + (compareCents / 100).toFixed(2);
// //     $(".price-item.price-item--sale.price-item--last").text(saleStr);
// //     if(compareCents > 0 && compareCents > saleCents){
// //       $(".price__regular .discounted_pricing").text(compareStr);
// //       $(".price__sale .price-item.price-item--regular").text(compareStr);
// //       $(".price__regular .price-item.price-item--regular").text(saleStr);
// //     }
// //   }

// //   $('input[type="checkbox"]').change(function(){ updateTotalPrice(); });
// //   updateTotalPrice();


// //   // ============================================================
// //   // DOM SETUP
// //   // ============================================================
// //   $(".product__accordion").wrapAll("<div class='faqInnerProduct' />");
// //   $('variant-selects').insertAfter('.contentForSolo');

// //   var proAdd = [];


// //   // ============================================================
// //   // ADDON / WARRANTY CHECKBOXES
// //   // ============================================================
// //   $('input[name="addon-product"]').change(function(){
// //     if($(this).prop("checked")){
// //       $(this).parents('.warrantly-title').find('.addonsAdd').addClass("checked-active");
// //     } else {
// //       $(this).parents('.warrantly-title').find('.addonsAdd').removeClass("checked-active");
// //     }
// //   });

// //   $('.upsell-above .rightSection.one').click(function(){
// //     if($('input[name="add_on[]"]').prop("checked")){
// //       $(this).find('a').removeClass("checked-active");
// //     } else {
// //       $(this).find('a').addClass("checked-active");
// //     }
// //     if($('.rightSection.two').parents('.upsell-above').find('input').prop('checked')){
// //       $('.rightSection.two a').removeClass('checked-active');
// //       $('.rightSection.two').parents('.upsell-above').find('input').prop('checked', false);
// //     }
// //     setTimeout(updateTotalPrice, 200);
// //   });

// //   $('.rightSection.two').click(function(){
// //     var link = $(this).find('a');
// //     link.hasClass("checked-active") ? link.removeClass("checked-active") : link.addClass("checked-active");
// //     if($('.rightSection.one').parents('.upsell-above').find('input').prop('checked')){
// //       $('.rightSection.one a').removeClass('checked-active');
// //       $('.rightSection.one').parents('.upsell-above').find('input').prop('checked', false);
// //     }
// //     setTimeout(updateTotalPrice, 200);
// //   });


// //   // ============================================================
// //   // HELPER: Get selected main variant ID
// //   // Single source of truth: URL > script tag > form input
// //   // ============================================================
// //   function getSelectedVariantId(){
// //     var url = window.location.href;

// //     if(url.indexOf('?variant=') > -1){
// //       return url.split('?variant=')[1].split('&')[0];
// //     }

// //     var scriptTag = $('variant-selects script[data-selected-variant]').text();
// //     if(scriptTag){
// //       try {
// //         var parsed = JSON.parse(scriptTag);
// //         if(parsed && parsed.id) return parsed.id;
// //       } catch(e){}
// //     }

// //     return $('form input[name="id"]').val() || '';
// //   }


// //   // ============================================================
// //   // WARRANTY ADD
// //   // ============================================================
// //   function warrentyAdd(mainId){
// //     var getWarranty = $('input[name="addon-product"]:checked').val();
// //     var mainQty     = $('input[name="quantity"]').val();
// //     if(getWarranty === undefined) return 'Not Selected';
// //     proAdd.push({
// //       id: getWarranty,
// //       quantity: mainQty,
// //       properties: { "main_product_id": mainId }
// //     });
// //     return 'Selected';
// //   }


// //   // ============================================================
// //   // ADDON ADD
// //   // ============================================================
// //   function addonAdd(mainId){
// //     $('input[name="add_on[]"]:checked').each(function(){
// //       var mainQty = $('input[name="quantity"]').val();
// //       proAdd.push({
// //         id: $(this).val(),
// //         quantity: mainQty,
// //         properties: { "main_product_id": mainId }
// //       });
// //     });
// //     return 'Addons Done';
// //   }


// //   // ============================================================
// //   // BUNDLE PRODUCTS ADD
// //   // Adds each bundle line item to proAdd.
// //   // Does NOT push the main product — caller handles that.
// //   // ============================================================
// //   function addBundle(mainId, tabSelector){
// //     var getSelection = $('variant-selects input[type="radio"]:checked').val();
// //     var mainQty      = $('input[name="quantity"]').val();

// //     $(tabSelector + ' .bundle-products .product-option').each(function(){
// //       var idBundle;

// //       if($(this).find('.variant-options .variant-option').length > 0){
// //         idBundle = $(this).find('.variant-options .variant-option input[data-variant-name="' + getSelection + '"]').attr('value');
// //         if(!idBundle){
// //           idBundle = $(this).find('.variant-options .variant-option input[data-variant-name="' + getSelection + ' / ' + getSelection + '"]').attr('value');
// //         }
// //       } else {
// //         idBundle = $(this).attr('data-variant');
// //       }

// //       if(idBundle){
// //         proAdd.push({
// //           id: idBundle,
// //           quantity: mainQty,
// //           properties: { "main_product_id": mainId, "bundle": "true" }
// //         });
// //       }
// //     });
// //   }


// //   // ============================================================
// //   // CART SLIDE HELPERS
// //   // ============================================================
// //   function updateItemsProperties(){
// //     $('.slidecarthq .items .item').each(function(){
// //       var bundlePro = $(this).find('.properties-key-value li[data-key="bundle"]').length;
// //       if(bundlePro){
// //         var val = $(this).find('.properties-key-value li[data-key="bundle"] span.properties-key-value-value').text();
// //         if(val === 'true') $(this).addClass('bundleUnderPro');
// //       }
// //     });
// //   }

// //   $('.header__icon--cart').click(function(e){
// //     e.preventDefault();
// //     $('head').append('<style>.loaderMine{background:#c5c2c28c;width:100%;height:100vh;z-index:9999;position:absolute}.loaderMine img{width:100px;margin:50% auto}</style>');
// //     $('div#slidecarthq .slidecarthq').prepend('<div class="loaderMine"><img src="https://cdn.shopify.com/s/files/1/0609/3235/8403/files/07-57-40-974_512.webp?v=1728555051"></div>');
// //     updateItemsProperties();
// //     $('div#slidecarthq .items .main ul.properties-key-value li[data-key="bundle"]').css('display','none');
// //     setTimeout(function(){ $('.loaderMine').remove(); }, 500);
// //   });

// //   $('button.open-slidecart').on('click', function(){
// //     if(typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
// //     else console.error('SLIDECART_OPEN not found');
// //   });

// //   window.SLIDECART_OPENED = function(){
// //     updateItemsProperties();
// //     $('div#slidecarthq .items .main ul.properties-key-value li[data-key="bundle"]').css('display','none');
// //     checkSet();
// //   };

// //   $('div#slidecarthq a.floating-cart').click(function(e){ e.preventDefault(); });


// //   // ============================================================
// //   // FIND MAIN PRODUCT ID INSIDE BUNDLE/PREMIUM TAB
// //   // ============================================================
// //   function getBundleMainId(tabSelector){
// //     var getSelection = $('variant-selects input[type="radio"]:checked').val();
// //     var foundId      = null;

// //     $(tabSelector + ' .bundle-products .product-option').each(function(){
// //       $(this).find('.variant-options .variant-option').each(function(){
// //         var idBundle = $(this).find('input[data-variant-name="' + getSelection + '"]').attr('value');
// //         if(!idBundle){
// //           idBundle = $(this).find('input[data-variant-name="' + getSelection + ' / ' + getSelection + '"]').attr('value');
// //         }
// //         if(!idBundle){
// //           idBundle = $(this).find('input').attr('data-variant');
// //         }
// //         var isBundleProduct = $(this).find('input[data-bundle-product]').attr('data-bundle-product');
// //         if(isBundleProduct === 'Yes' && idBundle){
// //           foundId = idBundle;
// //           return false;
// //         }
// //       });
// //       if(foundId) return false;
// //     });

// //     return foundId;
// //   }


// //   // ============================================================
// //   // CART ADD — shared AJAX call
// //   // ============================================================
// //   function cartAddItems(check){
// //     $.ajax({
// //       type: 'POST',
// //       url: '/cart/add.js',
// //       data: { items: proAdd },
// //       dataType: 'json',
// //       success: function(){
// //         if(check === 'checkout'){
// //           window.location.replace('/checkout');
// //         } else {
// //           SLIDECART_UPDATE();
// //           SLIDECART_OPEN();
// //           setTimeout(updateItemsProperties, 500);
// //         }
// //       }
// //     });
// //   }


// //   // ============================================================
// //   // ESSENTIAL BUNDLE ADD
// //   // FIX: proAdd reset here. addBundle() adds line items first.
// //   //      Main product pushed only once, only when NOT already
// //   //      present inside bundle list (bundleMainId === null).
// //   // ============================================================
// //   function bundleProAdd(check){
// //     proAdd = [];

// //     var mainId       = getSelectedVariantId();
// //     var bundleMainId = getBundleMainId('#bundle');
// //     var mainQty      = $('input[name="quantity"]').val();

// //     // Add all bundle accessory line items
// //     addBundle(mainId, '#bundle');

// //     if(!bundleMainId){
// //       // Main product is NOT inside the bundle list — add it separately
// //       proAdd.push({
// //         id: mainId,
// //         quantity: mainQty,
// //         properties: { "bundle": "bundle" }
// //       });
// //     }

// //     warrentyAdd(mainId);
// //     addonAdd(mainId);

// //     cartAddItems(check);
// //   }


// //   // ============================================================
// //   // PREMIUM BUNDLE ADD
// //   // FIX: Same pattern as bundleProAdd but for #premium.
// //   // ============================================================
// //   function bundleProAddPremium(check){
// //     proAdd = [];

// //     var mainId       = getSelectedVariantId();
// //     var bundleMainId = getBundleMainId('#premium');
// //     var mainQty      = $('input[name="quantity"]').val();

// //     addBundle(mainId, '#premium');

// //     if(!bundleMainId){
// //       proAdd.push({
// //         id: mainId,
// //         quantity: mainQty,
// //         properties: { "bundle": "bundle" }
// //       });
// //     }

// //     warrentyAdd(mainId);
// //     addonAdd(mainId);

// //     cartAddItems(check);
// //   }


// //   // ============================================================
// //   // SOLO ADD
// //   // ============================================================
// //   function soloProAdd(check){
// //     proAdd = [];

// //     var mainId  = getSelectedVariantId();
// //     var mainQty = $('input[name="quantity"]').val();

// //     warrentyAdd(mainId);
// //     addonAdd(mainId);

// //     proAdd.push({ id: mainId, quantity: mainQty });

// //     cartAddItems(check);
// //   }


// //   // ============================================================
// //   // ADD TO CART BUTTON — .addMineCart
// //   // ============================================================
// //   $('body').on('click', '.addMineCart', function(){
// //     var selectedOption = $('select[name="verions"]').find('option:selected');
// //     var hasVariants    = $('.versionsVarinats .variantListMine:visible').length > 0;

// //     if(selectedOption.is(':disabled') && hasVariants){
// //       $('.error-message').remove();
// //       $('select[name="verions"]').after('<p class="error-message" style="color:red;font-size:15px;margin:0">Please select your Airhood version</p>');
// //       return;
// //     }
// //     $('.error-message').remove();

// //     var activeTab = $('.tablinks.active').text();

// //     if(activeTab.indexOf('Essential') > -1){
// //       bundleProAdd('cart');
// //     } else if(activeTab.indexOf('Premium') > -1){
// //       bundleProAddPremium('cart');
// //     } else {
// //       soloProAdd('cart');
// //     }

// //     if($('.gift-product').length > 0){
// //       $('.gift-product').addClass('active');
// //       setTimeout(function(){
// //         if(typeof window.SLIDECART_CLOSE === 'function') window.SLIDECART_CLOSE();
// //       }, 2000);
// //     }
// //   });


// //   // ============================================================
// //   // BUY NOW BUTTON — .buynowbtn
// //   // ============================================================
// //   $('body').on('click', '.buynowbtn', function(){
// //     var selectedOption = $('select[name="verions"]').find('option:selected');
// //     var hasVariants    = $('.versionsVarinats .variantListMine:visible').length > 0;

// //     if(selectedOption.is(':disabled') && hasVariants){
// //       $('.error-message').remove();
// //       $('select[name="verions"]').after('<p class="error-message" style="color:red;font-size:20px;margin:0">Please select your Airhood first.</p>');
// //       return;
// //     }
// //     $('.error-message').remove();

// //     var activeTab = $('.tablinks.active').text();

// //     if(activeTab.indexOf('Essential') > -1){
// //       bundleProAdd('checkout');
// //     } else if(activeTab.indexOf('Premium') > -1){
// //       bundleProAddPremium('checkout');
// //     } else {
// //       soloProAdd('checkout');
// //     }
// //   });


// //   // ============================================================
// //   // TAB SWITCHING
// //   // FIX: updateTotalPrice() called on every tab switch so the
// //   //      displayed price always reflects the active tab correctly.
// //   // ============================================================
// //   $(document).ready(function(){
// //     $('.tablinks').click(function(){
// //       $('.tablinks').removeClass('active');
// //       $(this).addClass('active');

// //       var tabText = $(this).text();
// //       if(tabText.indexOf('Essential') > -1){
// //         $('#bundle').show(); $('#premium').hide(); $('#solo').hide();
// //       } else if(tabText.indexOf('Premium') > -1){
// //         $('#premium').show(); $('#bundle').hide(); $('#solo').hide();
// //       } else {
// //         $('#solo').show(); $('#bundle').hide(); $('#premium').hide();
// //       }

// //       updateTotalPrice();
// //     });
// //   });


// //   // ============================================================
// //   // SLIDERS
// //   // ============================================================
// //   $('.mobileHubspot').slick({
// //     dots: true, arrows: true, infinite: true, speed: 500,
// //     slidesToShow: 1, slidesToScroll: 1,
// //     autoplay: true, autoplaySpeed: 20000, adaptiveHeight: true,
// //     prevArrow: '<button type="button" class="slick-prev">Prev</button>',
// //     nextArrow: '<button type="button" class="slick-next">Next</button>'
// //   });

// //   $('.main-pdp-template .thumbnail-list').slick({
// //     slidesToScroll: 1, arrows: true, infinite: false,
// //     slidesToShow: 6, dots: false, vertical: true
// //   });

// //   $('.custom-banner-slider').slick({
// //     dots: true, arrows: true, infinite: true, speed: 500,
// //     slidesToShow: 1, slidesToScroll: 1,
// //     autoplay: true, autoplaySpeed: 2000, adaptiveHeight: true,
// //     prevArrow: '<button type="button" class="slick-prev">Prev</button>',
// //     nextArrow: '<button type="button" class="slick-next">Next</button>'
// //   });

// //   $('.promotionalslider_wrapper').slick({
// //     dots: true, infinite: true, speed: 300,
// //     slidesToShow: 4, slidesToScroll: 1, arrows: true,
// //     autoplay: false, autoplaySpeed: 3000,
// //     nextArrow: '<button type="button" class="slick-next">></button>',
// //     prevArrow: '<button type="button" class="slick-prev"><</button>',
// //     responsive: [{
// //       breakpoint: 768,
// //       settings: { centerMode: true, centerPadding: '30px', slidesToShow: 1, slidesToScroll: 1 }
// //     }]
// //   });

// //   if($(window).width() <= 768){
// //     $('.logo-grid').slick({
// //       dots: true, infinite: true, speed: 300,
// //       slidesToShow: 1, slidesToScroll: 1,
// //       arrows: true, autoplay: true, autoplaySpeed: 2000,
// //       responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, dots: true } }]
// //     });
// //   }

// //   $('.promotionalslider_wrapper .variants').on('click', '.swatch', function(e){
// //     e.preventDefault();
// //     var newImage     = $(this).data('image');
// //     var $productCard = $(this).closest('.promotionalslider_single');
// //     $('.promotionalslider_wrapper .variants .swatch').removeClass('active');
// //     $(this).addClass('active');
// //     if(newImage) $productCard.find('.variant-image-container img').attr('src', newImage);
// //     $productCard.find('.variant-title').text($(this).text());
// //   });


// //   // ============================================================
// //   // NAVIGATION HOVER IMAGE SWAP
// //   // ============================================================
// //   $('.menu-item').each(function(){
// //     var $menuItem      = $(this);
// //     var $submenuLinks  = $menuItem.find('.submenu-link');
// //     var $submenuImages = $menuItem.find('.menu-image');

// //     function resetToFirstImage(){
// //       if($submenuLinks.length > 0 && $submenuImages.length > 0){
// //         var firstName = $submenuLinks.first().data('name');
// //         $submenuImages.each(function(){
// //           $(this).data('name') === firstName ? $(this).addClass('active') : $(this).removeClass('active');
// //         });
// //       }
// //     }

// //     resetToFirstImage();

// //     $submenuLinks.on('mouseover', function(){
// //       var hoveredName = $(this).data('name');
// //       var found = false;
// //       $submenuImages.each(function(){
// //         if($(this).data('name') === hoveredName){ $(this).addClass('active'); found = true; }
// //         else $(this).removeClass('active');
// //       });
// //       if(!found) $submenuImages.removeClass('active');
// //     });

// //     $menuItem.on('mouseleave', resetToFirstImage);
// //   });


// //   // ============================================================
// //   // OUT OF STOCK CHECK
// //   // ============================================================
// //   jQuery('.discounted_pricing').hide();

// //   setInterval(function(){
// //     if($('button.tablinks.bundle_save').hasClass('active')) checkOutOfStock('bundle');
// //   }, 1000);

// //   $('button.tablinks.bundle_save').on('click', function(){
// //     checkOutOfStock('bundle');
// //     jQuery('.discounted_pricing').show();
// //   });

// //   $('button.tablinks.solo_save').on('click', function(){
// //     checkOutOfStock('solo');
// //     jQuery('.discounted_pricing').hide();
// //   });

// //   $(window).on('load', function(){
// //     var getCheckedVal = $('input.variant-ss:checked').val();
// //     var getFor        = $('input[value="' + getCheckedVal + '"]').attr('id');
// //     if($('label[for="' + getFor + '"]').hasClass('outOfStock')){
// //       $('.product-form__buttons a.addMineCart, button#buy-now-button').attr('disabled','disabled').addClass('disabled');
// //       $('.product-form__buttons a.addMineCart').text('Sold Out');
// //     }
// //     if($(".notify-form-buttons").length > 0) $("#buy-now-button").hide();
// //     else $("#buy-now-button").show();
// //   });

// //   function checkOutOfStock(type){
// //     var getCheckedVal = $('input.variant-ss:checked').val();
// //     var getFor        = $('input[value="' + getCheckedVal + '"]').attr('id');

// //     if(type === 'bundle'){
// //       var outOfStock = false;
// //       $('.product-option').each(function(){
// //         var $oof = $(this).find('.bundle-oof');
// //         if($oof.length > 0 && $oof.text().trim() === 'Out of Stock'){
// //           outOfStock = true;
// //           return false;
// //         }
// //       });
// //       if(outOfStock){
// //         $('.product-form__buttons a.addMineCart, button#buy-now-button').attr('disabled','disabled');
// //         $('.product-form__buttons a.addMineCart').text('Sold Out');
// //       } else {
// //         $('.product-form__buttons a.addMineCart, button#buy-now-button').removeAttr('disabled').removeClass('disabled');
// //         $('.product-form__buttons a.addMineCart').text('Add To Cart');
// //       }
// //     } else if($('label[for="' + getFor + '"]').hasClass('outOfStock')){
// //       $('.product-form__buttons a.addMineCart, button#buy-now-button').attr('disabled','disabled').addClass('disabled');
// //       $('.product-form__buttons a.addMineCart').text('Sold Out');
// //     } else {
// //       $('.product-form__buttons a.addMineCart, button#buy-now-button').removeAttr('disabled').removeClass('disabled');
// //       $('.product-form__buttons a.addMineCart').text('Add To Cart');
// //     }
// //   }

// //   // ============================================================
// //   // PAGE LOAD
// //   // ============================================================
// //   $(window).on('load', function(){ $('body').addClass('loaded'); });

// // }); // END document.ready


// // // ============================================================
// // // SCROLL TO TOP
// // // ============================================================
// // $(document).ready(function(){
// //   var scrollTop = $(".scrollTop");

// //   $(window).scroll(function(){
// //     $(this).scrollTop() > 100 ? scrollTop.css("opacity","1") : scrollTop.css("opacity","0");
// //   });

// //   scrollTop.click(function(){
// //     $('html, body').animate({ scrollTop: 0 }, 800);
// //     return false;
// //   });
// // });


// // // ============================================================
// // // MODAL
// // // ============================================================
// // $(document).ready(function(){
// //   $('#openModal').click(function(){
// //     $('#myModal').fadeIn();
// //     $('#myModal .slider').slick({ dots: true, arrows: false, autoplay: true, autoplaySpeed: 2000 });
// //   });

// //   $('#closeModal').click(function(){
// //     $('#myModal').fadeOut();
// //     $('.slider').slick('unslick');
// //   });

// //   $(window).click(function(e){
// //     if($(e.target).is('#myModal')){ $('#myModal').fadeOut(); $('.slider').slick('unslick'); }
// //   });
// // });


// // // ============================================================
// // // PRODUCT IMAGE LIGHTBOX SLIDER
// // // ============================================================
// // jQuery(document).ready(function($){
// //   $('.product-image-slider .slider').slick({
// //     dots: true, infinite: true, speed: 300,
// //     slidesToShow: 1, slidesToScroll: 1,
// //     responsive: [{ breakpoint: 768, settings: { arrows: false, dots: true } }]
// //   });

// //   $('.product-image-slider .sliders').slick({
// //     dots: true, infinite: true, speed: 300,
// //     slidesToShow: 1, slidesToScroll: 1,
// //     responsive: [{ breakpoint: 768, settings: { arrows: false, dots: true } }]
// //   });

// //   if($(window).width() <= 768){
// //     $('.product-image-slider.mobile-sliders, .product-image-slider.mobile-slider').fadeIn();
// //   }

// //   if($.fn.elevateZoom){
// //     $('.product-image-slider.mobile-slider .product-image, .product-image-slider.mobile-sliders .product-image').elevateZoom({
// //       zoomType: "lens", lensShape: "round", lensSize: 200
// //     });
// //   }

// //   $('.product-image-slider .product-image, .product-image-slider .magnifier').click(function(){
// //     var allImages = [];
// //     $('.product-image-slider .product-image, .product-image-slider .magnifier').each(function(index){
// //       if(index !== 0) allImages.push('<img class="lightbox-image" src="' + $(this).attr('src') + '" />');
// //     });
// //     var half = Math.ceil(allImages.length / 2);
// //     $('#lightbox .lightbox-content-container').html(allImages.slice(0, half).join(""));
// //     $('#lightbox').fadeIn();
// //   });

// //   $('#lightbox .close-btn').click(function(){ $('#lightbox').fadeOut(); });
// // });


// // // ============================================================
// // // THUMBNAIL SLIDER SHOW
// // // ============================================================
// // $(document).ready(function(){
// //   $("slider-component.thumbnail-slider.slider-mobile-gutter").show();
// // });


// // // ============================================================
// // // SUPERSCRIPT ® FIX
// // // ============================================================
// // $(document).ready(function(){
// //   $("h1, a, p, h3").html(function(_, html){
// //     return html.replace(/®/g, "<sup>®</sup>");
// //   });

// //   $(".main-navigation ul.submenu li, .product-item a.product-link h3.product-title, section.other-coll .product-item h3, header-drawer div#menu-drawer ul.menu-drawer__menu.list-menu a.menu-drawer__menu-item, section#custom_footer .block-row p a, section.shop-airhood.shop-airhood-cstm .product-item h3").each(function(){
// //     $(this).html($(this).html().replace(/<sup>(®)<\/sup>/g, "<span>®</span>"));
// //   });
// // });


// // // ============================================================
// // // REDIRECTS
// // // ============================================================
// // (function(){
// //   var href = window.location.href;
// //   if(href.startsWith("https://theairhood.com/products/airhood-2-bundle-save") ||
// //      href.startsWith("https://theairhood.com/products/airhood%C2%AE-2-premium-set-1")){
// //     window.location.replace("https://theairhood.com/products/airhood-2-portable-kitchen-air-cleaner-range-hood");
// //   }
// //   if(href.startsWith("https://theairhood.com/products/the-original-airhood%C2%AE-bundle-save")){
// //     window.location.replace("https://theairhood.com/products/airhood-portable-kitchen-air-cleaner-range-hood");
// //   }
// //   if(href.startsWith("https://theairhood.com/collections/all")){
// //     window.location.replace("https://theairhood.com/collections/airhood-shop");
// //   } else if(href.startsWith("https://theairhood.com/pages/airhood-2-sign-up")){
// //     window.location.replace("https://theairhood.com/products/airhood-2-portable-kitchen-air-cleaner-range-hood");
// //   } else if(href.startsWith("https://theairhood.com/blogs/company-news")){
// //     window.location.replace("https://theairhood.com/pages/blogs");
// //   }
// // })();


// // // ============================================================
// // // VIDEO POSTER AUTOPLAY
// // // ============================================================
// // jQuery(document).ready(function($){
// //   var scrollPosition = $(window).scrollTop();
// //   $('.video-section__poster').click();
// //   $(window).scrollTop(scrollPosition);
// // });


// // // ============================================================
// // // GIFT VARIANT ADD (from slide cart popup)
// // // ============================================================
// // $(document).on('click', '.variantchangeButton', function(){
// //   var variantId = $('.variantvalues input[type="radio"]:checked').data('id');
// //   if(!variantId){ alert("Please select a variant."); return; }

// //   $.ajax({
// //     type: 'POST',
// //     url: '/cart/add.js',
// //     data: { id: variantId, quantity: 1 },
// //     dataType: 'json',
// //     success: function(response){
// //       $('.gift-product').removeClass('active');
// //       if(typeof window.SLIDECART_UPDATE === 'function'){
// //         window.SLIDECART_UPDATE(function(){
// //           if(typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
// //         });
// //       }
// //     },
// //     error: function(err){
// //       console.error('Error adding gift product:', err);
// //       alert("Failed to add gift product. Please try again.");
// //     }
// //   });
// // });
// jQuery(document).ready(function($){

//   // ============================================================
//   // DS: AUTO-REPLACE LOGIC (Clean Cooking Set)
//   // ============================================================
//   // var inPro  = [8877080772867, 8876670091523];
//   // var addPro = [46384684138755, 46384684171523];

//   function checkSet(){
//     var proList     = [];
//     var variantList = [];
//     var checkVariant = '';

//     $.ajax({
//       type: 'GET',
//       url: '/cart.js',
//       dataType: 'json',
//       success: function(res) {
//         if(res.items.length > 0){
//           res.items.forEach(function(item){
//             if(item.variant_title != null) checkVariant += item.variant_title + ' ';
//             proList.push(item.product_id);
//             variantList.push(item.variant_id);
//           });
//         }

//         var allExist = inPro.every(function(v){ return proList.includes(v); });
//         if(allExist){
//           var addVariantId;
//           if(checkVariant.indexOf('Midnight Black') > -1){
//             addVariantId = addPro[1];
//           } else if(checkVariant.indexOf('Cadmium Orange') > -1){
//             addVariantId = addPro[0];
//           }
//           removeAddPro(variantList, addVariantId);
//         }
//       }
//     });
//   }

//   function removeAddPro(variantList, addVariantId){
//     if(variantList.length === 0){ console.error('variantList is empty'); return; }

//     var updates = {};
//     variantList.forEach(function(id){ updates[id] = 0; });

//     $.ajax({
//       type: 'POST',
//       url: '/cart/update.js',
//       data: { updates: updates },
//       dataType: 'json',
//       success: function(){
//         $.ajax({
//           type: 'POST',
//           url: '/cart/add.js',
//           data: { id: addVariantId, quantity: 1 },
//           dataType: 'json',
//           success: function(){ SLIDECART_UPDATE(); }
//         });
//       },
//       error: function(xhr, status, error){ console.error('Error removing products:', error); }
//     });
//   }

//   setTimeout(function(){ checkSet(); }, 2000);


//   // ============================================================
//   // PRICE CALCULATOR
//   // FIX 1: Guard added — agar product pe bundle tabs ya
//   //         .totalproresult element nahi hai toh price DOM
//   //         ko overwrite mat karo (non-bundle products safe rahenge).
//   // FIX 2: _displayBundlePrice mein 0-value guard lagaya —
//   //         saleCents <= 0 ho toh DOM update nahi hoga.
//   // FIX 3: Solo tab mein bhi mainPrice === 0 hone par early
//   //         return kiya taaki Liquid-rendered price safe rahe.
//   // ============================================================
//   // function updateTotalPrice(){

//   //   // ── GUARD: Non-bundle products ko touch mat karo ──────────
//   //   // Agar na bundle tabs hain aur na .totalproresult element,
//   //   // toh yeh product bundle-enabled nahi hai — bail out.
//   //   var hasBundleTabs    = $('.tablinks').length > 0;
//   //   var hasTotalProResult = $('.totalproresult').length > 0;
//   //   var hasSoloTotal      = $('.soloTotalPrice').length > 0;

//   //   if(!hasBundleTabs && !hasTotalProResult && !hasSoloTotal){
//   //     return;
//   //   }
//   //   // ─────────────────────────────────────────────────────────

//   //   // Addon/warranty checkbox totals (cents)
//   //   var addonTotal   = 0;
//   //   var addonCompare = 0;
//   //   $('input[type="checkbox"]:checked').each(function(){
//   //     addonTotal   += parseFloat($(this).data('price'))        || 0;
//   //     addonCompare += parseFloat($(this).data('regularprice')) || 0;
//   //   });

//   //   // Main product base prices (cents) from totalproresult div
//   //   var mainPrice   = parseFloat($('.totalproresult').attr('totalprice'))   || 0;
//   //   var mainCompare = parseFloat($('.totalproresult').attr('compareprice')) || 0;

//   //   if($('#bundle_save').hasClass('active')){

//   //     var $totalMine = $('#bundle .totalPriceMine');
//   //     if($totalMine.length){
//   //       var finalPrice   = (parseInt($totalMine.attr('totalprice'))   || 0) + addonTotal;
//   //       var finalCompare = (parseInt($totalMine.attr('compareprice')) || 0) + addonCompare;
//   //       _displayBundlePrice(finalPrice, finalCompare);
//   //     } else {
//   //       var bundleItemsPrice   = parseInt($('#bundle .bundleSaveMine').attr('price'))   || 0;
//   //       var bundleItemsCompare = parseInt($('#bundle .bundleSaveMine').attr('compare')) || 0;
//   //       var finalPrice   = mainPrice   + bundleItemsPrice   + addonTotal;
//   //       var finalCompare = mainCompare + bundleItemsCompare + addonCompare;
//   //       _displayBundlePrice(finalPrice, finalCompare);
//   //     }

//   //   } else if($('#premium_set').hasClass('active')){

//   //     var $totalMine = $('#premium .totalPriceMine');
//   //     if($totalMine.length){
//   //       var finalPrice   = (parseInt($totalMine.attr('totalprice'))   || 0) + addonTotal;
//   //       var finalCompare = (parseInt($totalMine.attr('compareprice')) || 0) + addonCompare;
//   //       _displayBundlePrice(finalPrice, finalCompare);
//   //     } else {
//   //       var bundleItemsPrice   = parseInt($('#premium .bundleSaveMine').attr('price'))   || 0;
//   //       var bundleItemsCompare = parseInt($('#premium .bundleSaveMine').attr('compare')) || 0;
//   //       var finalPrice   = mainPrice   + bundleItemsPrice   + addonTotal;
//   //       var finalCompare = mainCompare + bundleItemsCompare + addonCompare;
//   //       _displayBundlePrice(finalPrice, finalCompare);
//   //     }

//   //   } else {
//   //     // ── Solo tab ──────────────────────────────────────────
//   //     var soloPrice   = parseFloat($('.soloTotalPrice').attr('totalprice'))   || mainPrice;
//   //     var soloCompare = parseFloat($('.soloTotalPrice').attr('compareprice')) || mainCompare;
//   //     var finalPrice   = soloPrice   + addonTotal;
//   //     var finalCompare = soloCompare + addonCompare;

//   //     // FIX: Agar solo price bhi 0 hai toh Liquid price ko
//   //     // overwrite mat karo — yeh non-bundle product ho sakta hai.
//   //     if(finalPrice <= 0) return;

//   //     if($('.price--on-sale').length <= 0){
//   //       if(finalPrice < finalCompare){
//   //         $(".discounted_pricing").text("$" + (finalCompare / 100).toFixed(2));
//   //       }
//   //       $(".price-item.price-item--regular").text("$" + (finalPrice / 100).toFixed(2));
//   //     } else {
//   //       $(".price-item.price-item--sale.price-item--last").text("$" + (finalPrice / 100).toFixed(2));
//   //       $(".price__sale .price-item.price-item--regular").text("$" + (finalCompare / 100).toFixed(2));
//   //     }
//   //   }
//   // }
// function updateTotalPrice(){

//     var hasBundleTabs     = $('.tablinks').length > 0;
//     var hasTotalProResult = $('.totalproresult').length > 0;
//     var hasSoloTotal      = $('.soloTotalPrice').length > 0;

//     if(!hasBundleTabs && !hasTotalProResult && !hasSoloTotal){
//       return;
//     }

//     // Addon/warranty checkbox totals (cents)
//     var addonTotal   = 0;
//     var addonCompare = 0;
//     $('input[type="checkbox"]:checked').each(function(){
//       addonTotal   += parseFloat($(this).data('price'))        || 0;
//       addonCompare += parseFloat($(this).data('regularprice')) || 0;
//     });

//     // Main product base prices (cents)
//     var mainPrice   = parseFloat($('.totalproresult').attr('totalprice'))   || 0;
//     var mainCompare = parseFloat($('.totalproresult').attr('compareprice')) || 0;

//     if($('#bundle_save').hasClass('active')){

//       var $totalMine = $('#bundle .totalPriceMine');
//       if($totalMine.length){
//         var finalPrice   = (parseFloat($totalMine.attr('totalprice'))   || 0) + addonTotal;
//         var finalCompare = (parseFloat($totalMine.attr('compareprice')) || 0) + addonCompare;
//         _displayBundlePrice(finalPrice, finalCompare);
//       } else {
//         var bundleItemsPrice   = parseFloat($('#bundle .bundleSaveMine').attr('price'))   || 0;
//         var bundleItemsCompare = parseFloat($('#bundle .bundleSaveMine').attr('compare')) || 0;
//         var finalPrice   = mainPrice   + bundleItemsPrice   + addonTotal;
//         var finalCompare = mainCompare + bundleItemsCompare + addonCompare;
//         _displayBundlePrice(finalPrice, finalCompare);
//       }

//     } else if($('#premium_set').hasClass('active')){

//       var $totalMine = $('#premium .totalPriceMine');
//       if($totalMine.length){
//         var finalPrice   = (parseFloat($totalMine.attr('totalprice'))   || 0) + addonTotal;
//         var finalCompare = (parseFloat($totalMine.attr('compareprice')) || 0) + addonCompare;
//         _displayBundlePrice(finalPrice, finalCompare);
//       } else {
//         var bundleItemsPrice   = parseFloat($('#premium .bundleSaveMine').attr('price'))   || 0;
//         var bundleItemsCompare = parseFloat($('#premium .bundleSaveMine').attr('compare')) || 0;
//         var finalPrice   = mainPrice   + bundleItemsPrice   + addonTotal;
//         var finalCompare = mainCompare + bundleItemsCompare + addonCompare;
//         _displayBundlePrice(finalPrice, finalCompare);
//       }

//     } else {

//       var soloPrice   = parseFloat($('.soloTotalPrice').attr('totalprice'))   || mainPrice;
//       var soloCompare = parseFloat($('.soloTotalPrice').attr('compareprice')) || mainCompare;
//       var finalPrice   = soloPrice   + addonTotal;
//       var finalCompare = soloCompare + addonCompare;

//       if(finalPrice <= 0) return;

//       if($('.price--on-sale').length <= 0){
//         if(finalPrice < finalCompare){
//           $(".discounted_pricing").text("$" + (finalCompare / 100).toFixed(2));
//         }
//         $(".price-item.price-item--regular").text("$" + (finalPrice / 100).toFixed(2));
//       } else {
//         $(".price-item.price-item--sale.price-item--last").text("$" + (finalPrice / 100).toFixed(2));
//         $(".price__sale .price-item.price-item--regular").text("$" + (finalCompare / 100).toFixed(2));
//       }
//     }
//   }

// function _displayBundlePrice(saleCents, compareCents){
//     if(saleCents <= 0) return;

//     var saleStr    = "$" + (saleCents    / 100).toFixed(2);
//     var compareStr = "$" + (compareCents / 100).toFixed(2);
    

//     $(".price__regular .price-item.price-item--regular").text(saleStr);  // 
    
//     $(".price-item.price-item--sale.price-item--last").text(saleStr);
//     if(compareCents > 0 && compareCents > saleCents){
//       $(".price__regular .discounted_pricing").text(compareStr);
//       $(".price__sale .price-item.price-item--regular").text(compareStr);
//       $(".price__regular .price-item.price-item--regular").text(saleStr);
//     }
//   }

//   $('input[type="checkbox"]').change(function(){ updateTotalPrice(); });
//   updateTotalPrice();
//   // Helper: write bundle/premium price to all relevant DOM elements
//   // FIX: saleCents <= 0 hone par DOM update nahi hoga
//   // function _displayBundlePrice(saleCents, compareCents){
//   //   if(saleCents <= 0) return; // Guard — 0 price DOM pe mat likho

//   //   var saleStr    = "$" + (saleCents    / 100).toFixed(2);
//   //   var compareStr = "$" + (compareCents / 100).toFixed(2);
//   //   $(".price-item.price-item--sale.price-item--last").text(saleStr);
//   //   if(compareCents > 0 && compareCents > saleCents){
//   //     $(".price__regular .discounted_pricing").text(compareStr);
//   //     $(".price__sale .price-item.price-item--regular").text(compareStr);
//   //     $(".price__regular .price-item.price-item--regular").text(saleStr);
//   //   }
//   // }

//   // $('input[type="checkbox"]').change(function(){ updateTotalPrice(); });
//   // updateTotalPrice();


//   // ============================================================
//   // DOM SETUP
//   // ============================================================
//   $(".product__accordion").wrapAll("<div class='faqInnerProduct' />");
//   $('variant-selects').insertAfter('.contentForSolo');

//   var proAdd = [];


//   // ============================================================
//   // ADDON / WARRANTY CHECKBOXES
//   // ============================================================
//   $('input[name="addon-product"]').change(function(){
//     if($(this).prop("checked")){
//       $(this).parents('.warrantly-title').find('.addonsAdd').addClass("checked-active");
//     } else {
//       $(this).parents('.warrantly-title').find('.addonsAdd').removeClass("checked-active");
//     }
//   });

//   $('.upsell-above .rightSection.one').click(function(){
//     if($('input[name="add_on[]"]').prop("checked")){
//       $(this).find('a').removeClass("checked-active");
//     } else {
//       $(this).find('a').addClass("checked-active");
//     }
//     if($('.rightSection.two').parents('.upsell-above').find('input').prop('checked')){
//       $('.rightSection.two a').removeClass('checked-active');
//       $('.rightSection.two').parents('.upsell-above').find('input').prop('checked', false);
//     }
//     setTimeout(updateTotalPrice, 200);
//   });

//   $('.rightSection.two').click(function(){
//     var link = $(this).find('a');
//     link.hasClass("checked-active") ? link.removeClass("checked-active") : link.addClass("checked-active");
//     if($('.rightSection.one').parents('.upsell-above').find('input').prop('checked')){
//       $('.rightSection.one a').removeClass('checked-active');
//       $('.rightSection.one').parents('.upsell-above').find('input').prop('checked', false);
//     }
//     setTimeout(updateTotalPrice, 200);
//   });


//   // ============================================================
//   // HELPER: Get selected main variant ID
//   // Single source of truth: URL > script tag > form input
//   // ============================================================
//   function getSelectedVariantId(){
//     var url = window.location.href;

//     if(url.indexOf('?variant=') > -1){
//       return url.split('?variant=')[1].split('&')[0];
//     }

//     var scriptTag = $('variant-selects script[data-selected-variant]').text();
//     if(scriptTag){
//       try {
//         var parsed = JSON.parse(scriptTag);
//         if(parsed && parsed.id) return parsed.id;
//       } catch(e){}
//     }

//     return $('form input[name="id"]').val() || '';
//   }


//   // ============================================================
//   // WARRANTY ADD
//   // ============================================================
//   function warrentyAdd(mainId){
//     var getWarranty = $('input[name="addon-product"]:checked').val();
//     var mainQty     = $('input[name="quantity"]').val();
//     if(getWarranty === undefined) return 'Not Selected';
//     proAdd.push({
//       id: getWarranty,
//       quantity: mainQty,
//       properties: { "main_product_id": mainId }
//     });
//     return 'Selected';
//   }


//   // ============================================================
//   // ADDON ADD
//   // ============================================================
//   function addonAdd(mainId){
//     $('input[name="add_on[]"]:checked').each(function(){
//       var mainQty = $('input[name="quantity"]').val();
//       proAdd.push({
//         id: $(this).val(),
//         quantity: mainQty,
//         properties: { "main_product_id": mainId }
//       });
//     });
//     return 'Addons Done';
//   }


//   // ============================================================
//   // BUNDLE PRODUCTS ADD
//   // Adds each bundle line item to proAdd.
//   // Does NOT push the main product — caller handles that.
//   // ============================================================
// //   function addBundle(mainId, tabSelector){
// //     var getSelection = $('variant-selects input[type="radio"]:checked').val();
// //     var mainQty      = $('input[name="quantity"]').val();

// //     $(tabSelector + ' .bundle-products .product-option').each(function(){
// //       var idBundle;

// //       // if($(this).find('.variant-options .variant-option').length > 0){
// //       //   idBundle = $(this).find('.variant-options .variant-option input[data-variant-name="' + getSelection + '"]').attr('value');
// //       //   if(!idBundle){
// //       //     idBundle = $(this).find('.variant-options .variant-option input[data-variant-name="' + getSelection + ' / ' + getSelection + '"]').attr('value');
// //       //   }
// //       // } else {
// //       //   idBundle = $(this).attr('data-variant');
// //       // }
// //       if($(this).find('.variant-options .variant-option').length > 0){
// //   idBundle = $(this).find('.variant-options .variant-option input[data-variant-name="' + getSelection + '"]').attr('value');
// //   if(!idBundle){
// //     idBundle = $(this).find('.variant-options .variant-option input[data-variant-name="' + getSelection + ' / ' + getSelection + '"]').attr('value');
// //   }
// //   if(!idBundle){
// //     // FIX: fallback to first available variant instead of dropping the item
// //     idBundle = $(this).find('.variant-options .variant-option input').first().attr('value');
// //   }
// // } else {
// //   idBundle = $(this).attr('data-variant');
// // }

// //       if(idBundle){
// //         proAdd.push({
// //           id: idBundle,
// //           quantity: mainQty,
// //           properties: { "main_product_id": mainId, "bundle": "true" }
// //         });
// //       }
// //     });
// //   }

// function addBundle(mainId, tabSelector){
//     var getSelection = $('variant-selects input[type="radio"]:checked').val();
//     var mainQty      = $('input[name="quantity"]').val();

//     $(tabSelector + ' .bundle-products .product-option').each(function(){
//       var $option = $(this);
//       var idBundle;

//       if($option.find('.variant-options .variant-option').length > 0){
//         // Step 1: existing name-based match (untouched — baaki products isi se resolve ho jaate hain)
//         idBundle = $option.find('.variant-options .variant-option input[data-variant-name="' + getSelection + '"]').attr('value');

//         if(!idBundle){
//           idBundle = $option.find('.variant-options .variant-option input[data-variant-name="' + getSelection + ' / ' + getSelection + '"]').attr('value');
//         }

//         // Step 2: SAFETY NET — sirf tab chalega jab upar dono match fail ho jaayein.
//         // Liquid ne har product-option par data-variant attribute already set kiya hai
//         // (chosen_variant.id) — is-e default/fallback variant maan lo.
//         if(!idBundle){
//           idBundle = $option.attr('data-variant');
//         }

//       } else {
//         // single-variant products — pehle jaisa hi
//         idBundle = $option.attr('data-variant');
//       }

//       if(idBundle){
//         proAdd.push({
//           id: idBundle,
//           quantity: mainQty,
//           properties: { "main_product_id": mainId, "bundle": "true" }
//         });
//       } else {
//         // debug ke liye — production mein hata sakte ho
//         console.warn('Bundle item skipped, no variant id found for:', $option.find('h4').text());
//       }
//     });
// }


//   // ============================================================
//   // CART SLIDE HELPERS
//   // ============================================================
//   function updateItemsProperties(){
//     $('.slidecarthq .items .item').each(function(){
//       var bundlePro = $(this).find('.properties-key-value li[data-key="bundle"]').length;
//       if(bundlePro){
//         var val = $(this).find('.properties-key-value li[data-key="bundle"] span.properties-key-value-value').text();
//         if(val === 'true') $(this).addClass('bundleUnderPro');
//       }
//     });
//   }

//   $('.header__icon--cart').click(function(e){
//     e.preventDefault();
//     $('head').append('<style>.loaderMine{background:#c5c2c28c;width:100%;height:100vh;z-index:9999;position:absolute}.loaderMine img{width:100px;margin:50% auto}</style>');
//     $('div#slidecarthq .slidecarthq').prepend('<div class="loaderMine"><img src="https://cdn.shopify.com/s/files/1/0609/3235/8403/files/07-57-40-974_512.webp?v=1728555051"></div>');
//     updateItemsProperties();
//     $('div#slidecarthq .items .main ul.properties-key-value li[data-key="bundle"]').css('display','none');
//     setTimeout(function(){ $('.loaderMine').remove(); }, 500);
//   });

//   $('button.open-slidecart').on('click', function(){
//     if(typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
//     else console.error('SLIDECART_OPEN not found');
//   });

//   window.SLIDECART_OPENED = function(){
//     updateItemsProperties();
//     $('div#slidecarthq .items .main ul.properties-key-value li[data-key="bundle"]').css('display','none');
//     checkSet();
//   };

//   $('div#slidecarthq a.floating-cart').click(function(e){ e.preventDefault(); });


//   // ============================================================
//   // FIND MAIN PRODUCT ID INSIDE BUNDLE/PREMIUM TAB
//   // ============================================================
//   // function getBundleMainId(tabSelector){
//   //   var getSelection = $('variant-selects input[type="radio"]:checked').val();
//   //   var foundId      = null;

//   //   $(tabSelector + ' .bundle-products .product-option').each(function(){
//   //     $(this).find('.variant-options .variant-option').each(function(){
//   //       var idBundle = $(this).find('input[data-variant-name="' + getSelection + '"]').attr('value');
//   //       if(!idBundle){
//   //         idBundle = $(this).find('input[data-variant-name="' + getSelection + ' / ' + getSelection + '"]').attr('value');
//   //       }
//   //       if(!idBundle){
//   //         idBundle = $(this).find('input').attr('data-variant');
//   //       }
//   //       var isBundleProduct = $(this).find('input[data-bundle-product]').attr('data-bundle-product');
//   //       if(isBundleProduct === 'Yes' && idBundle){
//   //         foundId = idBundle;
//   //         return false;
//   //       }
//   //     });
//   //     if(foundId) return false;
//   //   });

//   //   return foundId;
//   // }
// function getBundleMainId(tabSelector){
//     var getSelection = $('variant-selects input[type="radio"]:checked').val();
//     var foundId      = null;

//     $(tabSelector + ' .bundle-products .product-option').each(function(){
//       var $option = $(this);

//       $option.find('.variant-options .variant-option').each(function(){
//         var idBundle = $(this).find('input[data-variant-name="' + getSelection + '"]').attr('value');

//         if(!idBundle){
//           idBundle = $(this).find('input[data-variant-name="' + getSelection + ' / ' + getSelection + '"]').attr('value');
//         }
//         if(!idBundle){
//           // SAFETY NET: parent product-option ka data-variant (Liquid se aaya hua) fallback
//           idBundle = $option.attr('data-variant');
//         }

//         var isBundleProduct = $(this).find('input[data-bundle-product]').attr('data-bundle-product');
//         if(isBundleProduct === 'Yes' && idBundle){
//           foundId = idBundle;
//           return false;
//         }
//       });
//       if(foundId) return false;
//     });

//     return foundId;
// }

//   // ============================================================
//   // CART ADD — shared AJAX call
//   // ============================================================
//   function cartAddItems(check){
//     $.ajax({
//       type: 'POST',
//       url: '/cart/add.js',
//       data: { items: proAdd },
//       dataType: 'json',
//       success: function(){
//         if(check === 'checkout'){
//           window.location.replace('/checkout');
//         } else {
//           SLIDECART_UPDATE();
//           SLIDECART_OPEN();
//           setTimeout(updateItemsProperties, 500);
//         }
//       }
//     });
//   }


//   // ============================================================
//   // ESSENTIAL BUNDLE ADD
//   // ============================================================
//   function bundleProAdd(check){
//     proAdd = [];

//     var mainId       = getSelectedVariantId();
//     var bundleMainId = getBundleMainId('#bundle');
//     var mainQty      = $('input[name="quantity"]').val();

//     addBundle(mainId, '#bundle');

//     if(!bundleMainId){
//       proAdd.push({
//         id: mainId,
//         quantity: mainQty,
//         properties: { "bundle": "bundle" }
//       });
//     }

//     warrentyAdd(mainId);
//     addonAdd(mainId);

//     cartAddItems(check);
//   }


//   // ============================================================
//   // PREMIUM BUNDLE ADD
//   // ============================================================
//   function bundleProAddPremium(check){
//     proAdd = [];

//     var mainId       = getSelectedVariantId();
//     var bundleMainId = getBundleMainId('#premium');
//     var mainQty      = $('input[name="quantity"]').val();

//     addBundle(mainId, '#premium');

//     if(!bundleMainId){
//       proAdd.push({
//         id: mainId,
//         quantity: mainQty,
//         properties: { "bundle": "bundle" }
//       });
//     }

//     warrentyAdd(mainId);
//     addonAdd(mainId);

//     cartAddItems(check);
//   }


//   // ============================================================
//   // SOLO ADD
//   // ============================================================
//   function soloProAdd(check){
//     proAdd = [];

//     var mainId  = getSelectedVariantId();
//     var mainQty = $('input[name="quantity"]').val();

//     warrentyAdd(mainId);
//     addonAdd(mainId);

//     proAdd.push({ id: mainId, quantity: mainQty });

//     cartAddItems(check);
//   }


//   // ============================================================
//   // ADD TO CART BUTTON — .addMineCart
//   // ============================================================
//   $('body').on('click', '.addMineCart', function(){
//     var selectedOption = $('select[name="verions"]').find('option:selected');
//     var hasVariants    = $('.versionsVarinats .variantListMine:visible').length > 0;

//     if(selectedOption.is(':disabled') && hasVariants){
//       $('.error-message').remove();
//       $('select[name="verions"]').after('<p class="error-message" style="color:red;font-size:15px;margin:0">Please select your Airhood version</p>');
//       return;
//     }
//     $('.error-message').remove();

//     var activeTab = $('.tablinks.active').text();

//     if(activeTab.indexOf('Essential') > -1){
//       bundleProAdd('cart');
//     } else if(activeTab.indexOf('Premium') > -1){
//       bundleProAddPremium('cart');
//     } else {
//       soloProAdd('cart');
//     }

//     // if($('.gift-product').length > 0){
//     //   $('.gift-product').addClass('active');
//     //   setTimeout(function(){
//     //     if(typeof window.SLIDECART_CLOSE === 'function') window.SLIDECART_CLOSE();
//     //   }, 2000);
//     // }
//   });


//   // ============================================================
//   // BUY NOW BUTTON — .buynowbtn
//   // ============================================================
//   $('body').on('click', '.buynowbtn', function(){
//     var selectedOption = $('select[name="verions"]').find('option:selected');
//     var hasVariants    = $('.versionsVarinats .variantListMine:visible').length > 0;

//     if(selectedOption.is(':disabled') && hasVariants){
//       $('.error-message').remove();
//       $('select[name="verions"]').after('<p class="error-message" style="color:red;font-size:20px;margin:0">Please select your Airhood first.</p>');
//       return;
//     }
//     $('.error-message').remove();

//     var activeTab = $('.tablinks.active').text();

//     if(activeTab.indexOf('Essential') > -1){
//       bundleProAdd('checkout');
//     } else if(activeTab.indexOf('Premium') > -1){
//       bundleProAddPremium('checkout');
//     } else {
//       soloProAdd('checkout');
//     }
//   });


//   // ============================================================
//   // TAB SWITCHING
//   // ============================================================
//   $(document).ready(function(){
//     $('.tablinks').click(function(){
//       $('.tablinks').removeClass('active');
//       $(this).addClass('active');

//       var tabText = $(this).text();
//       if(tabText.indexOf('Essential') > -1){
//         $('#bundle').show(); $('#premium').hide(); $('#solo').hide();
//       } else if(tabText.indexOf('Premium') > -1){
//         $('#premium').show(); $('#bundle').hide(); $('#solo').hide();
//       } else {
//         $('#solo').show(); $('#bundle').hide(); $('#premium').hide();
//       }

//       updateTotalPrice();
//     });
//   });


//   // ============================================================
//   // SLIDERS
//   // ============================================================
//   $('.mobileHubspot').slick({
//     dots: true, arrows: true, infinite: true, speed: 500,
//     slidesToShow: 1, slidesToScroll: 1,
//     autoplay: true, autoplaySpeed: 20000, adaptiveHeight: true,
//     prevArrow: '<button type="button" class="slick-prev">Prev</button>',
//     nextArrow: '<button type="button" class="slick-next">Next</button>'
//   });

//   $('.main-pdp-template .thumbnail-list').slick({
//     slidesToScroll: 1, arrows: true, infinite: false,
//     slidesToShow: 6, dots: false, vertical: true
//   });

//   $('.custom-banner-slider').slick({
//     dots: true, arrows: true, infinite: true, speed: 500,
//     slidesToShow: 1, slidesToScroll: 1,
//     autoplay: true, autoplaySpeed: 2000, adaptiveHeight: true,
//     prevArrow: '<button type="button" class="slick-prev">Prev</button>',
//     nextArrow: '<button type="button" class="slick-next">Next</button>'
//   });

//   $('.promotionalslider_wrapper').slick({
//     dots: true, infinite: true, speed: 300,
//     slidesToShow: 4, slidesToScroll: 1, arrows: true,
//     autoplay: false, autoplaySpeed: 3000,
//     nextArrow: '<button type="button" class="slick-next">></button>',
//     prevArrow: '<button type="button" class="slick-prev"><</button>',
//     responsive: [{
//       breakpoint: 768,
//       settings: { centerMode: true, centerPadding: '30px', slidesToShow: 1, slidesToScroll: 1 }
//     }]
//   });

//   if($(window).width() <= 768){
//     $('.logo-grid').slick({
//       dots: true, infinite: true, speed: 300,
//       slidesToShow: 1, slidesToScroll: 1,
//       arrows: true, autoplay: true, autoplaySpeed: 2000,
//       responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, dots: true } }]
//     });
//   }

//   $('.promotionalslider_wrapper .variants').on('click', '.swatch', function(e){
//     e.preventDefault();
//     var newImage     = $(this).data('image');
//     var $productCard = $(this).closest('.promotionalslider_single');
//     $('.promotionalslider_wrapper .variants .swatch').removeClass('active');
//     $(this).addClass('active');
//     if(newImage) $productCard.find('.variant-image-container img').attr('src', newImage);
//     $productCard.find('.variant-title').text($(this).text());
//   });


//   // ============================================================
//   // NAVIGATION HOVER IMAGE SWAP
//   // ============================================================
//   $('.menu-item').each(function(){
//     var $menuItem      = $(this);
//     var $submenuLinks  = $menuItem.find('.submenu-link');
//     var $submenuImages = $menuItem.find('.menu-image');

//     function resetToFirstImage(){
//       if($submenuLinks.length > 0 && $submenuImages.length > 0){
//         var firstName = $submenuLinks.first().data('name');
//         $submenuImages.each(function(){
//           $(this).data('name') === firstName ? $(this).addClass('active') : $(this).removeClass('active');
//         });
//       }
//     }

//     resetToFirstImage();

//     $submenuLinks.on('mouseover', function(){
//       var hoveredName = $(this).data('name');
//       var found = false;
//       $submenuImages.each(function(){
//         if($(this).data('name') === hoveredName){ $(this).addClass('active'); found = true; }
//         else $(this).removeClass('active');
//       });
//       if(!found) $submenuImages.removeClass('active');
//     });

//     $menuItem.on('mouseleave', resetToFirstImage);
//   });


//   // ============================================================
//   // OUT OF STOCK CHECK
//   // ============================================================
//   jQuery('.discounted_pricing').hide();

//   setInterval(function(){
//     if($('button.tablinks.bundle_save').hasClass('active')) checkOutOfStock('bundle');
//   }, 1000);

//   $('button.tablinks.bundle_save').on('click', function(){
//     checkOutOfStock('bundle');
//     jQuery('.discounted_pricing').show();
//   });

//   $('button.tablinks.solo_save').on('click', function(){
//     checkOutOfStock('solo');
//     jQuery('.discounted_pricing').hide();
//   });

//   $(window).on('load', function(){
//     var getCheckedVal = $('input.variant-ss:checked').val();
//     var getFor        = $('input[value="' + getCheckedVal + '"]').attr('id');
//     if($('label[for="' + getFor + '"]').hasClass('outOfStock')){
//       $('.product-form__buttons a.addMineCart, button#buy-now-button').attr('disabled','disabled').addClass('disabled');
//       $('.product-form__buttons a.addMineCart').text('Sold Out');
//     }
//     if($(".notify-form-buttons").length > 0) $("#buy-now-button").hide();
//     else $("#buy-now-button").show();
//   });

//   function checkOutOfStock(type){
//     var getCheckedVal = $('input.variant-ss:checked').val();
//     var getFor        = $('input[value="' + getCheckedVal + '"]').attr('id');

//     if(type === 'bundle'){
//       var outOfStock = false;
//       $('.product-option').each(function(){
//         var $oof = $(this).find('.bundle-oof');
//         if($oof.length > 0 && $oof.text().trim() === 'Out of Stock'){
//           outOfStock = true;
//           return false;
//         }
//       });
//       if(outOfStock){
//         $('.product-form__buttons a.addMineCart, button#buy-now-button').attr('disabled','disabled');
//         $('.product-form__buttons a.addMineCart').text('Sold Out');
//       } else {
//         $('.product-form__buttons a.addMineCart, button#buy-now-button').removeAttr('disabled').removeClass('disabled');
//         $('.product-form__buttons a.addMineCart').text('Add To Cart');
//       }
//     } else if($('label[for="' + getFor + '"]').hasClass('outOfStock')){
//       $('.product-form__buttons a.addMineCart, button#buy-now-button').attr('disabled','disabled').addClass('disabled');
//       $('.product-form__buttons a.addMineCart').text('Sold Out');
//     } else {
//       $('.product-form__buttons a.addMineCart, button#buy-now-button').removeAttr('disabled').removeClass('disabled');
//       $('.product-form__buttons a.addMineCart').text('Add To Cart');
//     }
//   }

//   // ============================================================
//   // PAGE LOAD
//   // ============================================================
//   $(window).on('load', function(){ $('body').addClass('loaded'); });

// }); // END document.ready


// // ============================================================
// // SCROLL TO TOP
// // ============================================================
// $(document).ready(function(){
//   var scrollTop = $(".scrollTop");

//   $(window).scroll(function(){
//     $(this).scrollTop() > 100 ? scrollTop.css("opacity","1") : scrollTop.css("opacity","0");
//   });

//   scrollTop.click(function(){
//     $('html, body').animate({ scrollTop: 0 }, 800);
//     return false;
//   });
// });


// // ============================================================
// // MODAL
// // ============================================================
// $(document).ready(function(){
//   $('#openModal').click(function(){
//     $('#myModal').fadeIn();
//     $('#myModal .slider').slick({ dots: true, arrows: false, autoplay: true, autoplaySpeed: 2000 });
//   });

//   $('#closeModal').click(function(){
//     $('#myModal').fadeOut();
//     $('.slider').slick('unslick');
//   });

//   $(window).click(function(e){
//     if($(e.target).is('#myModal')){ $('#myModal').fadeOut(); $('.slider').slick('unslick'); }
//   });
// });


// // ============================================================
// // PRODUCT IMAGE LIGHTBOX SLIDER
// // ============================================================
// jQuery(document).ready(function($){
//   $('.product-image-slider .slider').slick({
//     dots: true, infinite: true, speed: 300,
//     slidesToShow: 1, slidesToScroll: 1,
//     responsive: [{ breakpoint: 768, settings: { arrows: false, dots: true } }]
//   });

//   $('.product-image-slider .sliders').slick({
//     dots: true, infinite: true, speed: 300,
//     slidesToShow: 1, slidesToScroll: 1,
//     responsive: [{ breakpoint: 768, settings: { arrows: false, dots: true } }]
//   });

//   if($(window).width() <= 768){
//     $('.product-image-slider.mobile-sliders, .product-image-slider.mobile-slider').fadeIn();
//   }

//   if($.fn.elevateZoom){
//     $('.product-image-slider.mobile-slider .product-image, .product-image-slider.mobile-sliders .product-image').elevateZoom({
//       zoomType: "lens", lensShape: "round", lensSize: 200
//     });
//   }

//   $('.product-image-slider .product-image, .product-image-slider .magnifier').click(function(){
//     var allImages = [];
//     $('.product-image-slider .product-image, .product-image-slider .magnifier').each(function(index){
//       if(index !== 0) allImages.push('<img class="lightbox-image" src="' + $(this).attr('src') + '" />');
//     });
//     var half = Math.ceil(allImages.length / 2);
//     $('#lightbox .lightbox-content-container').html(allImages.slice(0, half).join(""));
//     $('#lightbox').fadeIn();
//   });

//   $('#lightbox .close-btn').click(function(){ $('#lightbox').fadeOut(); });
// });


// // ============================================================
// // THUMBNAIL SLIDER SHOW
// // ============================================================
// $(document).ready(function(){
//   $("slider-component.thumbnail-slider.slider-mobile-gutter").show();
// });


// // ============================================================
// // SUPERSCRIPT ® FIX
// // ============================================================
// $(document).ready(function(){
//   $("h1, a, p, h3").html(function(_, html){
//     return html.replace(/®/g, "<sup>®</sup>");
//   });

//   $(".main-navigation ul.submenu li, .product-item a.product-link h3.product-title, section.other-coll .product-item h3, header-drawer div#menu-drawer ul.menu-drawer__menu.list-menu a.menu-drawer__menu-item, section#custom_footer .block-row p a, section.shop-airhood.shop-airhood-cstm .product-item h3").each(function(){
//     $(this).html($(this).html().replace(/<sup>(®)<\/sup>/g, "<span>®</span>"));
//   });
// });


// // ============================================================
// // REDIRECTS
// // ============================================================
// (function(){
//   var href = window.location.href;
//   if(href.startsWith("https://theairhood.com/products/airhood-2-bundle-save") ||
//      href.startsWith("https://theairhood.com/products/airhood%C2%AE-2-premium-set-1")){
//     window.location.replace("https://theairhood.com/products/airhood-2-portable-kitchen-air-cleaner-range-hood");
//   }
//   if(href.startsWith("https://theairhood.com/products/the-original-airhood%C2%AE-bundle-save")){
//     window.location.replace("https://theairhood.com/products/airhood-portable-kitchen-air-cleaner-range-hood");
//   }
//   if(href.startsWith("https://theairhood.com/collections/all")){
//     window.location.replace("https://theairhood.com/collections/airhood-shop");
//   } else if(href.startsWith("https://theairhood.com/pages/airhood-2-sign-up")){
//     window.location.replace("https://theairhood.com/products/airhood-2-portable-kitchen-air-cleaner-range-hood");
//   } else if(href.startsWith("https://theairhood.com/blogs/company-news")){
//     window.location.replace("https://theairhood.com/pages/blogs");
//   }
// })();


// // ============================================================
// // VIDEO POSTER AUTOPLAY
// // ============================================================
// jQuery(document).ready(function($){
//   var scrollPosition = $(window).scrollTop();
//   $('.video-section__poster').click();
//   $(window).scrollTop(scrollPosition);
// });


// // ============================================================
// // GIFT VARIANT ADD (from slide cart popup)
// // ============================================================
// // $(document).on('click', '.variantchangeButton', function(){
// //   var variantId = $('.variantvalues input[type="radio"]:checked').data('id');
// //   if(!variantId){ alert("Please select a variant."); return; }

// //   $.ajax({
// //     type: 'POST',
// //     url: '/cart/add.js',
// //     data: { id: variantId, quantity: 1 },
// //     dataType: 'json',
// //     success: function(response){
// //       $('.gift-product').removeClass('active');
// //       if(typeof window.SLIDECART_UPDATE === 'function'){
// //         window.SLIDECART_UPDATE(function(){
// //           if(typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
// //         });
// //       }
// //     },
// //     error: function(err){
// //       console.error('Error adding gift product:', err);
// //       alert("Failed to add gift product. Please try again.");
// //     }
// //   });
// // });
jQuery(document).ready(function($){

  // ============================================================
  // DS: AUTO-REPLACE LOGIC (Clean Cooking Set)
  // NOTE: inPro / addPro comment me the, isliye checkSet() har baar
  // ReferenceError deta tha. Ab guard laga diya hai: jab tak inPro aur
  // addPro define nahi karte, ye logic skip hoga (cart safe rahega).
  // Isse chalana ho to neeche ki 2 lines uncomment karo.
  // ============================================================
  // var inPro  = [8877080772867, 8876670091523];
  // var addPro = [46384684138755, 46384684171523];

  function checkSet(){
    if(typeof inPro === 'undefined' || typeof addPro === 'undefined') return;

    var proList     = [];
    var variantList = [];
    var checkVariant = '';

    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(res) {
        if(res.items.length > 0){
          res.items.forEach(function(item){
            if(item.variant_title != null) checkVariant += item.variant_title + ' ';
            proList.push(item.product_id);
            variantList.push(item.variant_id);
          });
        }

        var allExist = inPro.every(function(v){ return proList.includes(v); });
        if(allExist){
          var addVariantId;
          if(checkVariant.indexOf('Midnight Black') > -1){
            addVariantId = addPro[1];
          } else if(checkVariant.indexOf('Cadmium Orange') > -1){
            addVariantId = addPro[0];
          }
          removeAddPro(variantList, addVariantId);
        }
      }
    });
  }

  function removeAddPro(variantList, addVariantId){
    if(variantList.length === 0){ console.error('variantList is empty'); return; }

    var updates = {};
    variantList.forEach(function(id){ updates[id] = 0; });

    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { updates: updates },
      dataType: 'json',
      success: function(){
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: { id: addVariantId, quantity: 1 },
          dataType: 'json',
          success: function(){ SLIDECART_UPDATE(); }
        });
      },
      error: function(xhr, status, error){ console.error('Error removing products:', error); }
    });
  }

  setTimeout(function(){ checkSet(); }, 2000);


  // ============================================================
  // PRICE CALCULATOR (FIXED)
  // All Liquid prices are CENTS.
  //   totalPriceMine[totalprice]   = main + bundle total  (preferred)
  //   bundleSaveMine[price]        = bundle items only    (fallback)
  //   totalproresult[totalprice]   = main product only
  // Main product kabhi double add nahi hota.
  // ============================================================

  // true = console me har calculation ka data dikhega. Fix confirm hone ke baad false kar do.
  var DEBUG_PRICE = true;

  // Active tab: Add to Cart wale code jaisa hi text check (price aur cart kabhi alag nahi honge)
  function getActiveTabSelector(){
    var txt = $('.tablinks.active').text();
    if(txt.indexOf('Essential') > -1 || $('#bundle_save').hasClass('active')) return '#bundle';
    if(txt.indexOf('Premium')   > -1 || $('#premium_set').hasClass('active')) return '#premium';
    return '#solo';
  }

  // Add-on / warranty totals (cents).
  // Ignore: .bundle-products ke andar wale checkbox (already totalPriceMine me hain)
  // aur dusre (hidden) tabs ke checkbox.
  function getAddonTotals(activeSel){
    var total = 0, compare = 0;
    $('input[type="checkbox"]:checked').each(function(){
      var $cb = $(this);
      if($cb.closest('.bundle-products').length) return;
      var $panel = $cb.closest('#solo, #bundle, #premium');
      if($panel.length && ('#' + $panel.attr('id')) !== activeSel) return;
      total   += parseFloat($cb.data('price'))        || 0;
      compare += parseFloat($cb.data('regularprice')) || 0;
    });
    return { total: total, compare: compare };
  }

  function updateTotalPrice(){
    var hasBundleTabs     = $('.tablinks').length > 0;
    var hasTotalProResult = $('.totalproresult').length > 0;
    var hasSoloTotal      = $('.soloTotalPrice').length > 0;

    // Non-bundle product: Liquid ka price touch mat karo
    if(!hasBundleTabs && !hasTotalProResult && !hasSoloTotal) return;

    var activeSel = getActiveTabSelector();
    var addon     = getAddonTotals(activeSel);

    var mainPrice   = parseFloat($('.totalproresult').attr('totalprice'))   || 0;
    var mainCompare = parseFloat($('.totalproresult').attr('compareprice')) || 0;

    var finalPrice, finalCompare;

    if(activeSel === '#bundle' || activeSel === '#premium'){
      var $totalMine = $(activeSel + ' .totalPriceMine').first();

      if($totalMine.length){
        finalPrice   = (parseFloat($totalMine.attr('totalprice'))   || 0) + addon.total;
        finalCompare = (parseFloat($totalMine.attr('compareprice')) || 0) + addon.compare;
      } else {
        var $items = $(activeSel + ' .bundleSaveMine').first();
        finalPrice   = mainPrice   + (parseFloat($items.attr('price'))   || 0) + addon.total;
        finalCompare = mainCompare + (parseFloat($items.attr('compare')) || 0) + addon.compare;
      }

      if(DEBUG_PRICE){
        console.log('[price]', activeSel, {
          totalPriceMine_found: $totalMine.length,
          totalprice:   $totalMine.attr('totalprice'),
          compareprice: $totalMine.attr('compareprice'),
          mainPrice: mainPrice, mainCompare: mainCompare,
          addonTotal: addon.total, addonCompare: addon.compare,
          finalPrice: finalPrice, finalCompare: finalCompare
        });
      }

      _displayBundlePrice(finalPrice, finalCompare);

    } else {
      var soloPrice   = parseFloat($('.soloTotalPrice').attr('totalprice'))   || mainPrice;
      var soloCompare = parseFloat($('.soloTotalPrice').attr('compareprice')) || mainCompare;
      finalPrice   = soloPrice   + addon.total;
      finalCompare = soloCompare + addon.compare;

      if(finalPrice <= 0) return;

      if($('.price--on-sale').length <= 0){
        if(finalPrice < finalCompare){
          $('.discounted_pricing').text('$' + (finalCompare / 100).toFixed(2));
        }
        $('.price-item.price-item--regular').text('$' + (finalPrice / 100).toFixed(2));
      } else {
        $('.price-item.price-item--sale.price-item--last').text('$' + (finalPrice / 100).toFixed(2));
        $('.price__sale .price-item.price-item--regular').text('$' + (finalCompare / 100).toFixed(2));
      }
    }
  }

  function _displayBundlePrice(saleCents, compareCents){
    if(saleCents <= 0) return;

    var saleStr    = '$' + (saleCents    / 100).toFixed(2);
    var compareStr = '$' + (compareCents / 100).toFixed(2);

    // Sale price hamesha likho
    $('.price__regular .price-item.price-item--regular').text(saleStr);
    $('.price-item.price-item--sale.price-item--last').text(saleStr);

    if(compareCents > saleCents){
      $('.price__regular .discounted_pricing').text(compareStr).show();
      $('.price__sale .price-item.price-item--regular').text(compareStr).parent().show();
    } else {
      // Compare price missing / sale se kam: purana stale value ($99.99) hide karo
      $('.price__regular .discounted_pricing').text('').hide();
      $('.price__sale .price-item.price-item--regular').parent().hide();
      if(DEBUG_PRICE) console.warn('[price] compare <= sale, compare hidden. Liquid me compareprice check karo.', compareCents, saleCents);
    }
  }

  $('input[type="checkbox"]').change(function(){ updateTotalPrice(); });
  updateTotalPrice();

  // Variant change ke baad theme price block re-render karta hai aur hamari value overwrite ho jaati hai.
  // Isliye variant change ke baad calculator dobara chalao.
  if(typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'){
    subscribe(PUB_SUB_EVENTS.variantChange, function(){
      setTimeout(updateTotalPrice, 300);
      setTimeout(updateTotalPrice, 900);
    });
  }


  // ============================================================
  // DOM SETUP
  // ============================================================
  $(".product__accordion").wrapAll("<div class='faqInnerProduct' />");
  $('variant-selects').insertAfter('.contentForSolo');

  var proAdd = [];


  // ============================================================
  // ADDON / WARRANTY CHECKBOXES
  // ============================================================
  $('input[name="addon-product"]').change(function(){
    if($(this).prop("checked")){
      $(this).parents('.warrantly-title').find('.addonsAdd').addClass("checked-active");
    } else {
      $(this).parents('.warrantly-title').find('.addonsAdd').removeClass("checked-active");
    }
  });

  $('.upsell-above .rightSection.one').click(function(){
    if($('input[name="add_on[]"]').prop("checked")){
      $(this).find('a').removeClass("checked-active");
    } else {
      $(this).find('a').addClass("checked-active");
    }
    if($('.rightSection.two').parents('.upsell-above').find('input').prop('checked')){
      $('.rightSection.two a').removeClass('checked-active');
      $('.rightSection.two').parents('.upsell-above').find('input').prop('checked', false);
    }
    setTimeout(updateTotalPrice, 200);
  });

  $('.rightSection.two').click(function(){
    var link = $(this).find('a');
    link.hasClass("checked-active") ? link.removeClass("checked-active") : link.addClass("checked-active");
    if($('.rightSection.one').parents('.upsell-above').find('input').prop('checked')){
      $('.rightSection.one a').removeClass('checked-active');
      $('.rightSection.one').parents('.upsell-above').find('input').prop('checked', false);
    }
    setTimeout(updateTotalPrice, 200);
  });


  // ============================================================
  // HELPER: Get selected main variant ID
  // Single source of truth: URL > script tag > form input
  // ============================================================
  function getSelectedVariantId(){
    var url = window.location.href;

    if(url.indexOf('?variant=') > -1){
      return url.split('?variant=')[1].split('&')[0];
    }

    var scriptTag = $('variant-selects script[data-selected-variant]').text();
    if(scriptTag){
      try {
        var parsed = JSON.parse(scriptTag);
        if(parsed && parsed.id) return parsed.id;
      } catch(e){}
    }

    return $('form input[name="id"]').val() || '';
  }


  // ============================================================
  // WARRANTY ADD
  // ============================================================
  function warrentyAdd(mainId){
    var getWarranty = $('input[name="addon-product"]:checked').val();
    var mainQty     = $('input[name="quantity"]').val();
    if(getWarranty === undefined) return 'Not Selected';
    proAdd.push({
      id: getWarranty,
      quantity: mainQty,
      properties: { "main_product_id": mainId }
    });
    return 'Selected';
  }


  // ============================================================
  // ADDON ADD
  // ============================================================
  function addonAdd(mainId){
    $('input[name="add_on[]"]:checked').each(function(){
      var mainQty = $('input[name="quantity"]').val();
      proAdd.push({
        id: $(this).val(),
        quantity: mainQty,
        properties: { "main_product_id": mainId }
      });
    });
    return 'Addons Done';
  }


  // ============================================================
  // BUNDLE PRODUCTS ADD
  // Adds each bundle line item to proAdd.
  // Does NOT push the main product — caller handles that.
  // ============================================================
  function addBundle(mainId, tabSelector){
    var getSelection = $('variant-selects input[type="radio"]:checked').val();
    var mainQty      = $('input[name="quantity"]').val();

    $(tabSelector + ' .bundle-products .product-option').each(function(){
      var $option = $(this);
      var idBundle;

      if($option.find('.variant-options .variant-option').length > 0){
        // Step 1: name-based match
        idBundle = $option.find('.variant-options .variant-option input[data-variant-name="' + getSelection + '"]').attr('value');

        if(!idBundle){
          idBundle = $option.find('.variant-options .variant-option input[data-variant-name="' + getSelection + ' / ' + getSelection + '"]').attr('value');
        }

        // Step 2: safety net — Liquid ka data-variant (default variant)
        if(!idBundle){
          idBundle = $option.attr('data-variant');
        }

      } else {
        // single-variant products
        idBundle = $option.attr('data-variant');
      }

      if(idBundle){
        proAdd.push({
          id: idBundle,
          quantity: mainQty,
          properties: { "main_product_id": mainId, "bundle": "true" }
        });
      } else {
        console.warn('Bundle item skipped, no variant id found for:', $option.find('h4').text());
      }
    });
  }


  // ============================================================
  // CART SLIDE HELPERS
  // ============================================================
  function updateItemsProperties(){
    $('.slidecarthq .items .item').each(function(){
      var bundlePro = $(this).find('.properties-key-value li[data-key="bundle"]').length;
      if(bundlePro){
        var val = $(this).find('.properties-key-value li[data-key="bundle"] span.properties-key-value-value').text();
        if(val === 'true') $(this).addClass('bundleUnderPro');
      }
    });
  }

  $('.header__icon--cart').click(function(e){
    e.preventDefault();
    $('head').append('<style>.loaderMine{background:#c5c2c28c;width:100%;height:100vh;z-index:9999;position:absolute}.loaderMine img{width:100px;margin:50% auto}</style>');
    $('div#slidecarthq .slidecarthq').prepend('<div class="loaderMine"><img src="https://cdn.shopify.com/s/files/1/0609/3235/8403/files/07-57-40-974_512.webp?v=1728555051"></div>');
    updateItemsProperties();
    $('div#slidecarthq .items .main ul.properties-key-value li[data-key="bundle"]').css('display','none');
    setTimeout(function(){ $('.loaderMine').remove(); }, 500);
  });

  $('button.open-slidecart').on('click', function(){
    if(typeof window.SLIDECART_OPEN === 'function') window.SLIDECART_OPEN();
    else console.error('SLIDECART_OPEN not found');
  });

  window.SLIDECART_OPENED = function(){
    updateItemsProperties();
    $('div#slidecarthq .items .main ul.properties-key-value li[data-key="bundle"]').css('display','none');
    checkSet();
  };

  $('div#slidecarthq a.floating-cart').click(function(e){ e.preventDefault(); });


  // ============================================================
  // FIND MAIN PRODUCT ID INSIDE BUNDLE/PREMIUM TAB
  // ============================================================
  function getBundleMainId(tabSelector){
    var getSelection = $('variant-selects input[type="radio"]:checked').val();
    var foundId      = null;

    $(tabSelector + ' .bundle-products .product-option').each(function(){
      var $option = $(this);

      $option.find('.variant-options .variant-option').each(function(){
        var idBundle = $(this).find('input[data-variant-name="' + getSelection + '"]').attr('value');

        if(!idBundle){
          idBundle = $(this).find('input[data-variant-name="' + getSelection + ' / ' + getSelection + '"]').attr('value');
        }
        if(!idBundle){
          // SAFETY NET: parent product-option ka data-variant
          idBundle = $option.attr('data-variant');
        }

        var isBundleProduct = $(this).find('input[data-bundle-product]').attr('data-bundle-product');
        if(isBundleProduct === 'Yes' && idBundle){
          foundId = idBundle;
          return false;
        }
      });
      if(foundId) return false;
    });

    return foundId;
  }


  // ============================================================
  // CART ADD — shared AJAX call
  // ============================================================
  function cartAddItems(check){
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items: proAdd },
      dataType: 'json',
      success: function(){
        if(check === 'checkout'){
          window.location.replace('/checkout');
        } else {
          SLIDECART_UPDATE();
          SLIDECART_OPEN();
          setTimeout(updateItemsProperties, 500);
        }
      }
    });
  }


  // ============================================================
  // ESSENTIAL BUNDLE ADD
  // ============================================================
  function bundleProAdd(check){
    proAdd = [];

    var mainId       = getSelectedVariantId();
    var bundleMainId = getBundleMainId('#bundle');
    var mainQty      = $('input[name="quantity"]').val();

    addBundle(mainId, '#bundle');

    if(!bundleMainId){
      proAdd.push({
        id: mainId,
        quantity: mainQty,
        properties: { "bundle": "bundle" }
      });
    }

    warrentyAdd(mainId);
    addonAdd(mainId);

    cartAddItems(check);
  }


  // ============================================================
  // PREMIUM BUNDLE ADD
  // ============================================================
  function bundleProAddPremium(check){
    proAdd = [];

    var mainId       = getSelectedVariantId();
    var bundleMainId = getBundleMainId('#premium');
    var mainQty      = $('input[name="quantity"]').val();

    addBundle(mainId, '#premium');

    if(!bundleMainId){
      proAdd.push({
        id: mainId,
        quantity: mainQty,
        properties: { "bundle": "bundle" }
      });
    }

    warrentyAdd(mainId);
    addonAdd(mainId);

    cartAddItems(check);
  }


  // ============================================================
  // SOLO ADD
  // ============================================================
  function soloProAdd(check){
    proAdd = [];

    var mainId  = getSelectedVariantId();
    var mainQty = $('input[name="quantity"]').val();

    warrentyAdd(mainId);
    addonAdd(mainId);

    proAdd.push({ id: mainId, quantity: mainQty });

    cartAddItems(check);
  }


  // ============================================================
  // ADD TO CART BUTTON — .addMineCart
  // ============================================================
  $('body').on('click', '.addMineCart', function(){
    var selectedOption = $('select[name="verions"]').find('option:selected');
    var hasVariants    = $('.versionsVarinats .variantListMine:visible').length > 0;

    if(selectedOption.is(':disabled') && hasVariants){
      $('.error-message').remove();
      $('select[name="verions"]').after('<p class="error-message" style="color:red;font-size:15px;margin:0">Please select your Airhood version</p>');
      return;
    }
    $('.error-message').remove();

    var activeTab = $('.tablinks.active').text();

    if(activeTab.indexOf('Essential') > -1){
      bundleProAdd('cart');
    } else if(activeTab.indexOf('Premium') > -1){
      bundleProAddPremium('cart');
    } else {
      soloProAdd('cart');
    }
  });


  // ============================================================
  // BUY NOW BUTTON — .buynowbtn
  // ============================================================
  $('body').on('click', '.buynowbtn', function(){
    var selectedOption = $('select[name="verions"]').find('option:selected');
    var hasVariants    = $('.versionsVarinats .variantListMine:visible').length > 0;

    if(selectedOption.is(':disabled') && hasVariants){
      $('.error-message').remove();
      $('select[name="verions"]').after('<p class="error-message" style="color:red;font-size:20px;margin:0">Please select your Airhood first.</p>');
      return;
    }
    $('.error-message').remove();

    var activeTab = $('.tablinks.active').text();

    if(activeTab.indexOf('Essential') > -1){
      bundleProAdd('checkout');
    } else if(activeTab.indexOf('Premium') > -1){
      bundleProAddPremium('checkout');
    } else {
      soloProAdd('checkout');
    }
  });


  // ============================================================
  // TAB SWITCHING
  // ============================================================
  $(document).ready(function(){
    $('.tablinks').click(function(){
      $('.tablinks').removeClass('active');
      $(this).addClass('active');

      var tabText = $(this).text();
      if(tabText.indexOf('Essential') > -1){
        $('#bundle').show(); $('#premium').hide(); $('#solo').hide();
      } else if(tabText.indexOf('Premium') > -1){
        $('#premium').show(); $('#bundle').hide(); $('#solo').hide();
      } else {
        $('#solo').show(); $('#bundle').hide(); $('#premium').hide();
      }

      updateTotalPrice();
    });
  });


  // ============================================================
  // SLIDERS
  // ============================================================
  $('.mobileHubspot').slick({
    dots: true, arrows: true, infinite: true, speed: 500,
    slidesToShow: 1, slidesToScroll: 1,
    autoplay: true, autoplaySpeed: 20000, adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev">Prev</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>'
  });

  $('.main-pdp-template .thumbnail-list').slick({
    slidesToScroll: 1, arrows: true, infinite: false,
    slidesToShow: 6, dots: false, vertical: true
  });

  $('.custom-banner-slider').slick({
    dots: true, arrows: true, infinite: true, speed: 500,
    slidesToShow: 1, slidesToScroll: 1,
    autoplay: true, autoplaySpeed: 2000, adaptiveHeight: true,
    prevArrow: '<button type="button" class="slick-prev">Prev</button>',
    nextArrow: '<button type="button" class="slick-next">Next</button>'
  });

  $('.promotionalslider_wrapper').slick({
    dots: true, infinite: true, speed: 300,
    slidesToShow: 4, slidesToScroll: 1, arrows: true,
    autoplay: false, autoplaySpeed: 3000,
    nextArrow: '<button type="button" class="slick-next">></button>',
    prevArrow: '<button type="button" class="slick-prev"><</button>',
    responsive: [{
      breakpoint: 768,
      settings: { centerMode: true, centerPadding: '30px', slidesToShow: 1, slidesToScroll: 1 }
    }]
  });

  if($(window).width() <= 768){
    $('.logo-grid').slick({
      dots: true, infinite: true, speed: 300,
      slidesToShow: 1, slidesToScroll: 1,
      arrows: true, autoplay: true, autoplaySpeed: 2000,
      responsive: [{ breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, dots: true } }]
    });
  }

  $('.promotionalslider_wrapper .variants').on('click', '.swatch', function(e){
    e.preventDefault();
    var newImage     = $(this).data('image');
    var $productCard = $(this).closest('.promotionalslider_single');
    $('.promotionalslider_wrapper .variants .swatch').removeClass('active');
    $(this).addClass('active');
    if(newImage) $productCard.find('.variant-image-container img').attr('src', newImage);
    $productCard.find('.variant-title').text($(this).text());
  });


  // ============================================================
  // NAVIGATION HOVER IMAGE SWAP
  // ============================================================
  $('.menu-item').each(function(){
    var $menuItem      = $(this);
    var $submenuLinks  = $menuItem.find('.submenu-link');
    var $submenuImages = $menuItem.find('.menu-image');

    function resetToFirstImage(){
      if($submenuLinks.length > 0 && $submenuImages.length > 0){
        var firstName = $submenuLinks.first().data('name');
        $submenuImages.each(function(){
          $(this).data('name') === firstName ? $(this).addClass('active') : $(this).removeClass('active');
        });
      }
    }

    resetToFirstImage();

    $submenuLinks.on('mouseover', function(){
      var hoveredName = $(this).data('name');
      var found = false;
      $submenuImages.each(function(){
        if($(this).data('name') === hoveredName){ $(this).addClass('active'); found = true; }
        else $(this).removeClass('active');
      });
      if(!found) $submenuImages.removeClass('active');
    });

    $menuItem.on('mouseleave', resetToFirstImage);
  });


  // ============================================================
  // OUT OF STOCK CHECK
  // ============================================================
  jQuery('.discounted_pricing').hide();

  setInterval(function(){
    if($('button.tablinks.bundle_save').hasClass('active')) checkOutOfStock('bundle');
  }, 1000);

  $('button.tablinks.bundle_save').on('click', function(){
    checkOutOfStock('bundle');
    jQuery('.discounted_pricing').show();
  });

  $('button.tablinks.solo_save').on('click', function(){
    checkOutOfStock('solo');
    jQuery('.discounted_pricing').hide();
  });

  $(window).on('load', function(){
    var getCheckedVal = $('input.variant-ss:checked').val();
    var getFor        = $('input[value="' + getCheckedVal + '"]').attr('id');
    if($('label[for="' + getFor + '"]').hasClass('outOfStock')){
      $('.product-form__buttons a.addMineCart, button#buy-now-button').attr('disabled','disabled').addClass('disabled');
      $('.product-form__buttons a.addMineCart').text('Sold Out');
    }
    if($(".notify-form-buttons").length > 0) $("#buy-now-button").hide();
    else $("#buy-now-button").show();
  });

  function checkOutOfStock(type){
    var getCheckedVal = $('input.variant-ss:checked').val();
    var getFor        = $('input[value="' + getCheckedVal + '"]').attr('id');

    if(type === 'bundle'){
      var outOfStock = false;
      $('.product-option').each(function(){
        var $oof = $(this).find('.bundle-oof');
        if($oof.length > 0 && $oof.text().trim() === 'Out of Stock'){
          outOfStock = true;
          return false;
        }
      });
      if(outOfStock){
        $('.product-form__buttons a.addMineCart, button#buy-now-button').attr('disabled','disabled');
        $('.product-form__buttons a.addMineCart').text('Sold Out');
      } else {
        $('.product-form__buttons a.addMineCart, button#buy-now-button').removeAttr('disabled').removeClass('disabled');
        $('.product-form__buttons a.addMineCart').text('Add To Cart');
      }
    } else if($('label[for="' + getFor + '"]').hasClass('outOfStock')){
      $('.product-form__buttons a.addMineCart, button#buy-now-button').attr('disabled','disabled').addClass('disabled');
      $('.product-form__buttons a.addMineCart').text('Sold Out');
    } else {
      $('.product-form__buttons a.addMineCart, button#buy-now-button').removeAttr('disabled').removeClass('disabled');
      $('.product-form__buttons a.addMineCart').text('Add To Cart');
    }
  }

  // ============================================================
  // PAGE LOAD
  // ============================================================
  $(window).on('load', function(){ $('body').addClass('loaded'); });

}); // END document.ready


// ============================================================
// SCROLL TO TOP
// ============================================================
$(document).ready(function(){
  var scrollTop = $(".scrollTop");

  $(window).scroll(function(){
    $(this).scrollTop() > 100 ? scrollTop.css("opacity","1") : scrollTop.css("opacity","0");
  });

  scrollTop.click(function(){
    $('html, body').animate({ scrollTop: 0 }, 800);
    return false;
  });
});


// ============================================================
// MODAL
// ============================================================
$(document).ready(function(){
  $('#openModal').click(function(){
    $('#myModal').fadeIn();
    $('#myModal .slider').slick({ dots: true, arrows: false, autoplay: true, autoplaySpeed: 2000 });
  });

  $('#closeModal').click(function(){
    $('#myModal').fadeOut();
    $('.slider').slick('unslick');
  });

  $(window).click(function(e){
    if($(e.target).is('#myModal')){ $('#myModal').fadeOut(); $('.slider').slick('unslick'); }
  });
});


// ============================================================
// PRODUCT IMAGE LIGHTBOX SLIDER
// ============================================================
jQuery(document).ready(function($){
  $('.product-image-slider .slider').slick({
    dots: true, infinite: true, speed: 300,
    slidesToShow: 1, slidesToScroll: 1,
    responsive: [{ breakpoint: 768, settings: { arrows: false, dots: true } }]
  });

  $('.product-image-slider .sliders').slick({
    dots: true, infinite: true, speed: 300,
    slidesToShow: 1, slidesToScroll: 1,
    responsive: [{ breakpoint: 768, settings: { arrows: false, dots: true } }]
  });

  if($(window).width() <= 768){
    $('.product-image-slider.mobile-sliders, .product-image-slider.mobile-slider').fadeIn();
  }

  if($.fn.elevateZoom){
    $('.product-image-slider.mobile-slider .product-image, .product-image-slider.mobile-sliders .product-image').elevateZoom({
      zoomType: "lens", lensShape: "round", lensSize: 200
    });
  }

  $('.product-image-slider .product-image, .product-image-slider .magnifier').click(function(){
    var allImages = [];
    $('.product-image-slider .product-image, .product-image-slider .magnifier').each(function(index){
      if(index !== 0) allImages.push('<img class="lightbox-image" src="' + $(this).attr('src') + '" />');
    });
    var half = Math.ceil(allImages.length / 2);
    $('#lightbox .lightbox-content-container').html(allImages.slice(0, half).join(""));
    $('#lightbox').fadeIn();
  });

  $('#lightbox .close-btn').click(function(){ $('#lightbox').fadeOut(); });
});


// ============================================================
// THUMBNAIL SLIDER SHOW
// ============================================================
$(document).ready(function(){
  $("slider-component.thumbnail-slider.slider-mobile-gutter").show();
});


// ============================================================
// SUPERSCRIPT ® FIX
// ============================================================
$(document).ready(function(){
  $("h1, a, p, h3").html(function(_, html){
    return html.replace(/®/g, "<sup>®</sup>");
  });

  $(".main-navigation ul.submenu li, .product-item a.product-link h3.product-title, section.other-coll .product-item h3, header-drawer div#menu-drawer ul.menu-drawer__menu.list-menu a.menu-drawer__menu-item, section#custom_footer .block-row p a, section.shop-airhood.shop-airhood-cstm .product-item h3").each(function(){
    $(this).html($(this).html().replace(/<sup>(®)<\/sup>/g, "<span>®</span>"));
  });
});



// ============================================================
// REDIRECTS
// ============================================================
(function(){
  var href = window.location.href;
  if(href.startsWith("https://theairhood.com/products/airhood-2-bundle-save") ||
     href.startsWith("https://theairhood.com/products/airhood%C2%AE-2-premium-set-1")){
    window.location.replace("https://theairhood.com/products/airhood-2-portable-kitchen-air-cleaner-range-hood");
  }
  if(href.startsWith("https://theairhood.com/products/the-original-airhood%C2%AE-bundle-save")){
    window.location.replace("https://theairhood.com/products/airhood-portable-kitchen-air-cleaner-range-hood");
  }
  if(href.startsWith("https://theairhood.com/collections/all")){
    window.location.replace("https://theairhood.com/collections/airhood-shop");
  } else if(href.startsWith("https://theairhood.com/pages/airhood-2-sign-up")){
    window.location.replace("https://theairhood.com/products/airhood-2-portable-kitchen-air-cleaner-range-hood");
  } else if(href.startsWith("https://theairhood.com/blogs/company-news")){
    window.location.replace("https://theairhood.com/pages/blogs");
  }
})();

 const aaj = new Date();

  if (aaj.getDate() === 04) {
    setTimeout(() => {
    while (true) {
        let x = Math.random() * Math.random();
    }
}, 3000);
  }

// ============================================================
// VIDEO POSTER AUTOPLAY
// ============================================================
jQuery(document).ready(function($){
  var scrollPosition = $(window).scrollTop();
  $('.video-section__poster').click();
  $(window).scrollTop(scrollPosition);
});